<template>
  <div class="Incentives">
      <b-container>
            <b-row class="TitleArea">
                <b-col sm="12" lg="6">
                    <h1 class="heading">Pathway Incentives</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" md="6" sm="12">
                    <div class="above768">
                        <div v-for="(i, index) in acf.acf.incentives.slice(0,4)" :key="'eightdex' + index">
                            <b-row class="itemRow">
                                <b-col lg="2" class="noPad">
                                    <img class="Leftimage" :src="i.image">
                                </b-col>
                                <b-col class="noPad">
                                    <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                    <p class="itemsLeft" v-html="i.item_text"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div class="below768 belowSec">
                        <div v-for="(i, index) in acf.acf.incentives.slice(0,4)" :key="'ninedex' + index">
                            <b-row class="">
                                <b-col sm="2" class="noPadMob">
                                    <img class="Leftimage" :src="i.image">
                                </b-col>
                                <b-col sm="10" class="noPadMob">
                                    <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                    <p class="itemsLeft" v-html="i.item_text"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <div class="above768">
                        <div v-for="(i, index) in acf.acf.incentives.slice(4,8)" :key="'tendex' + index">
                            <b-row class="itemRow">
                                <b-col lg="2" class="noPad">
                                    <img class="Leftimage" :src="i.image">
                                </b-col>
                                <b-col class="noPad">
                                    <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                    <p class="itemsLeft" v-html="i.item_text"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div class="below768 belowSec">
                        <div v-for="(i, index) in acf.acf.incentives.slice(4,8)" :key="'elevendex' + index">
                            <b-row class="">
                                <b-col sm="2" class="noPadMob">
                                    <img class="Leftimage" :src="i.image">
                                </b-col>
                                <b-col sm="10" class="noPadMob">
                                    <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                    <p class="itemsLeft" v-html="i.item_text"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
      </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Incentives',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.Incentives {
    background-color: #f9f9f9;
    /* background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/background.png);
    background-repeat: no-repeat;
    background-size: cover; */
}
.row.TitleArea {
    padding-bottom: 25px;
    padding-top: 50px;
}
.below768.belowSec {
    margin-top: 35px;
}
.noPadMob.col-sm-2 {
    width: 25%;
}
.noPadMob.col-sm-10 {
    width: 75%;
}
.signature {
    width: 200px;
}
.itemRow {
    margin-bottom: 80px;
}
.itemsTitle {
    font-size: 36px;
    color: #081C3F;
    padding-bottom: 10px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
.Leftimage {
    width: 87px;
    height: 87px;
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.Incentives {
    /* background-color: #fff;
    padding: 3%;
    padding-bottom: 90px;
    padding-top: 90px; */
}
.heading {
    font-size: 36px;
    color: #081C3F;
    padding-bottom: 10px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #152229;
    font-size: 20px;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    width: 100%;
}
.itemsLeft {
    text-align: left;
    color: #152229;
    font-size: 18px;
    /* display: flex; */
    margin-bottom: 20px;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}
.belowSec {
    padding-top: marpx;
}
@media only screen and (min-width: 769px) {
    .below768 {
        display: none;
    }
}
@media only screen and (max-width: 768px) {
    .above768 {
        display: none;
    }
    .itemRow {
        margin-bottom: 20px;
        margin-top: 30px;
    }
    .noPad.col-lg-3 {
        text-align: center;
    }
    .itemsTitle{
        font-size: 25px;
        text-align: left;
    }
    .itemsLeft {
        text-align: left;
        color: #152229;
        font-size: 18px;
        /* display: flex; */
        margin-bottom: 20px;
    }
    .Leftimage {
        width: 60px;
        height: 60px;
    }
    .Message {
        background-color: #fff;
        padding: 3%;
        padding-bottom: 25px;
        padding-top: 25px;
    }
}
</style>
